var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21681 11.9569C4.41724 8.1155 7.97483 5.5 11.9994 5.5C16.024 5.5 19.5815 8.1155 20.782 11.9569L20.9517 12.5L20.782 13.0431C19.5815 16.8845 16.024 19.5 11.9994 19.5C7.97483 19.5 4.41724 16.8845 3.21681 13.0431L3.04709 12.5L3.21681 11.9569ZM11.9994 3.5C7.10006 3.5 2.7692 6.684 1.30785 11.3603L1.04492 12.2017L0.951704 12.5L1.04492 12.7983L1.30785 13.6397C2.7692 18.316 7.10006 21.5 11.9994 21.5C16.8987 21.5 21.2296 18.316 22.6909 13.6397L22.9539 12.7983L23.0471 12.5L22.9539 12.2017L22.6909 11.3603C21.2296 6.684 16.8987 3.5 11.9994 3.5ZM9.99939 12.5C9.99939 11.3954 10.8948 10.5 11.9994 10.5C13.104 10.5 13.9994 11.3954 13.9994 12.5C13.9994 13.6046 13.104 14.5 11.9994 14.5C10.8948 14.5 9.99939 13.6046 9.99939 12.5ZM11.9994 8.5C9.79025 8.5 7.99939 10.2909 7.99939 12.5C7.99939 14.7091 9.79025 16.5 11.9994 16.5C14.2085 16.5 15.9994 14.7091 15.9994 12.5C15.9994 10.2909 14.2085 8.5 11.9994 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5603293531ab505a411dd66e801d1e67.svg";
export { ForwardRef as ReactComponent };